import React, { useRef, useState } from "react";
import axios from "axios";
import serverConfig from "../../../utilities/serverConfig.json";
import apiConfig from "../../../utilities/apiConfig.json";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const DeleteVisitModal = ({ id }) => {
  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const closeModalBtn = useRef(null);

  const deleteEventAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url + apiConfig.api.deleteAPIs.deleteEvent + id,
        {},
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          closeModalBtn.current.click();
          navigate(-1);
          toast.success(response.data.message);
        } else {
          if (typeof response.data.errors === "string") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error.message);
      });
  };

  return (
    <div
      className="modal fade"
      id="deleteVisitModal"
      tabIndex="-1"
      aria-labelledby="deleteVisitModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title"
              id="deleteVisitModalLabel"
              data-bs-dismiss="modal"
            >
              حذف نوبت
            </h5>
            <button
              type="button"
              className="btn-close"
              ref={closeModalBtn}
              data-bs-dismiss="modal"
              aria-label="بستن"
            ></button>
          </div>
          <div className="modal-body">
            آیا از حذف این نوبت از لیست نوبت‌ها اطمینان دارید ؟
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              انصراف
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={deleteEventAPI}
              disabled={loading}
            >
              {loading ? "در حال حذف..." : "حذف نوبت"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteVisitModal;
